import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPerronlengte = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={20}
    height={20}
    viewBox='0 0 20 20'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M20 7.08331L19.65 7.37498H19.64L16.84 9.70831C16.75 9.79165 16.61 9.83331 16.49 9.83331C16.37 9.83331 16.24 9.79165 16.14 9.70831C15.94 9.54165 15.94 9.28331 16.14 9.11665L18.09 7.49165H1.9L3.85 9.11665C4.05 9.28331 4.05 9.54165 3.85 9.70831C3.76 9.79165 3.62 9.83331 3.5 9.83331C3.38 9.83331 3.25 9.79165 3.15 9.70831L0 7.08331L3.15 4.45831C3.35 4.29165 3.66 4.29165 3.86 4.45831C4.06 4.62498 4.06 4.88331 3.86 5.04998L1.91 6.67498H18.09L16.14 5.04998C15.94 4.88331 15.94 4.62498 16.14 4.45831C16.34 4.29165 16.65 4.29165 16.85 4.45831L20 7.08331Z' />
    <path d='M3 13.75C3 13.5166 3.22 13.3333 3.5 13.3333H16.5C16.78 13.3333 17 13.5166 17 13.75C17 13.9833 16.78 14.1666 16.5 14.1666H3.5C3.22 14.1666 3 13.9833 3 13.75Z' />
  </svg>
);
export default SvgPerronlengte;
